import {createSvgIcon, SvgIcon} from "@mui/material";
import {
  AdminPanelSettingsOutlined,
  AppsOutlined,
  ArticleOutlined,
  AssignmentOutlined,
  BallotOutlined,
  BoltOutlined,
  BubbleChartOutlined,
  CategoryOutlined,
  ChangeCircleOutlined,
  ChatBubbleOutlineOutlined,
  CheckCircleOutlined,
  ContentPasteSearchOutlined,
  DynamicFormOutlined,
  EditOutlined,
  ExtensionOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  FormatOverlineOutlined,
  GamepadOutlined,
  GroupsOutlined,
  HandymanOutlined,
  HelpOutlineOutlined,
  HistoryEduOutlined,
  HomeOutlined,
  ImageOutlined,
  ImageSearchOutlined,
  LayersOutlined,
  LockOutlined,
  LooksOneOutlined,
  PublicOutlined,
  SearchOutlined,
  SettingsOutlined,
  ShapeLineOutlined,
  StarOutlined,
  TaskAltOutlined,
  TimelineOutlined,
  ViewComfyOutlined,
  ViewInArOutlined,
  WebAssetOutlined
} from "@mui/icons-material";
import {ReactNode} from "react";

export class Icon {
  constructor(readonly name: string, readonly iconType: typeof SvgIcon) {
  }
}

export const ICONS: Icon[] = [
  new Icon("admin_panel_settings", AdminPanelSettingsOutlined),
  new Icon("apps", AppsOutlined),
  new Icon("assets", WebAssetOutlined),
  new Icon("assignment", AssignmentOutlined),
  new Icon("article", ArticleOutlined),
  new Icon("ballot", BallotOutlined),
  new Icon("bolt", BoltOutlined),
  new Icon("category", CategoryOutlined),
  new Icon("bubble_chart", BubbleChartOutlined),
  new Icon("change_circle", ChangeCircleOutlined),
  new Icon("check_circle", CheckCircleOutlined),
  new Icon("chat", ChatBubbleOutlineOutlined),
  new Icon("content_search", ContentPasteSearchOutlined),
  new Icon("dynamic_form", DynamicFormOutlined),
  new Icon("edit", EditOutlined),
  new Icon("extension", ExtensionOutlined),
  new Icon("folder", FolderOutlined),
  new Icon("folder_open", FolderOpenOutlined),
  new Icon("format_overline", FormatOverlineOutlined),
  new Icon("gamepad", GamepadOutlined),
  new Icon("groups", GroupsOutlined),
  new Icon("home", HomeOutlined),
  new Icon("image", ImageOutlined),
  new Icon("image_search", ImageSearchOutlined),
  new Icon("layers", LayersOutlined),
  new Icon("lock", LockOutlined),
  new Icon("one", LooksOneOutlined),
  new Icon("public", PublicOutlined),
  new Icon("scribe", HistoryEduOutlined),
  new Icon("search", SearchOutlined),
  new Icon("settings", SettingsOutlined),
  new Icon("shape_line", ShapeLineOutlined),
  new Icon("star", StarOutlined),
  new Icon("task", TaskAltOutlined),
  new Icon("timeline", TimelineOutlined),
  new Icon("tools", HandymanOutlined),
  new Icon("users", GroupsOutlined),
  new Icon("view_in_ar", ViewInArOutlined),
  new Icon("view_comfy", ViewComfyOutlined),
];

export function findIcon(name: string): typeof SvgIcon {
  let icon = ICONS.find(icon => icon.name == name);
  return icon?.iconType || HelpOutlineOutlined;
}

export function createIcon(path: ReactNode) {
  return createSvgIcon(path, "");
}
